import { Report } from "@material-ui/icons";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Grid, SvgIcon } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  tile: {
    height: "80px",
    backgroundColor: "#FFF",
    textAlign: "center",
    width: "80%",
    cursor: "pointer",
    color: "#393939",
    padding: "5%",
    border: "#67729429",
    "&:hover": {
      backgroundColor: "#3f51b5",
      color: "#F5F7FA",
    },
  },
  analyticwindow: {
    backgroundColor: "#F5F7FA",
    color: "#393939",
    width: "300px",
  },
  button: {
    marginRight: "5px",
    borderRadius: "10px",
  },
});

function MisSalesReport() {
  const classes = useStyles();

  const history = useHistory();

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [cards, setCards] = useState([
    {
      id: 0,
      name: "Global Report",
      link: "viewmissalesreport",
    },
    {
      id: 1,
      name: "Advice Tracking",
      link: "viewmissalesreport",
    },
    {
      id: 2,
      name: "Advice V/s Customers",
      link: "viewmissalesreport",
    },
    {
      id: 3,
      name: "Broker Linking Status",
      link: "viewmissalesreport",
    },
    {
      id: 4,
      name: "Decision Making",
      link: "viewmissalesreport",
    },
    {
      id: 5,
      name: "Onboarding completion",
      link: "viewmissalesreport",
    },
    {
      id: 6,
      name: "Investor Age",
      link: "viewmissalesreport",
    },
    {
      id: 7,
      name: "Days To Renewal",
      link: "viewmissalesreport",
    },
    {
      id: 8,
      name: "Inactive Period",
      link: "viewmissalesreport",
    },
    {
      id: 9,
      name: "User wise Data",
      link: "viewmissalesreport",
    },
    {
      id: 10,
      name: "Advice Creation",
      link: "cdtcreateadvice",
    },
  ]);

  const goTomisSalesReport = (event, menuObject, index) => {
    if (menuObject.link) {
      history.push({
        pathname: menuObject.link,
        name: menuObject.id,
        cardName: menuObject.name,
        state: index,
      });
    }
  };

  // Customer Delight Executive

  return (
    <>
      <Grid container style={{ marginTop: "20px" }} className={"prospectgrids"}>
        {cards.map((item, index) => {
          if (item.name == "Advice Creation") {
            if (
              localStorage.getItem("empRole") ===
                "Customer Delight Executive" ||
              localStorage.getItem("empRole") === "Research Team" ||
              localStorage.getItem("empRole") === "CEO" ||
              localStorage.getItem("empRole") === "CTO"
            ) {
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  key={index}
                  selected={selectedIndex === index}
                  onClick={(event) => goTomisSalesReport(event, item, index)}
                >
                  <Paper className={classes.tile}>
                    <Typography variant="h6">{item.name}</Typography>
                  </Paper>
                </Grid>
              );
            }
          } else {
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                key={index}
                selected={selectedIndex === index}
                onClick={(event) => goTomisSalesReport(event, item, index)}
              >
                <Paper className={classes.tile}>
                  <Typography variant="h6">{item.name}</Typography>
                </Paper>
              </Grid>
            );
          }
          {
            /* return (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={index}
              selected={selectedIndex === index}
              onClick={(event) => goTomisSalesReport(event, item, index)}
            >
              <Paper className={classes.tile}>
                <>
                  <Typography variant="h6">{item.name}</Typography>
                </>
              </Paper>
            </Grid>
          ); */
          }
        })}
      </Grid>
    </>
    // <div className='salescardsParent'>

    //   {cards.map((item, index)=>{
    //     return(
    //     <div className='salescards'
    //       onClick={(event)=>goTomisSalesReport(event, item, index)}
    //     >
    //       {item.name}
    //     </div>
    //     )
    //   })}

    // </div>
  );
}

export default MisSalesReport;
